import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../../_services/authentification.service';
import { Role } from '../../_models/oauth.models'
import { ZeroService } from 'src/app/_services/zero/zero.service';
import { REST_SERVICES } from 'src/app/_services/settings';
import { ToastrService } from 'ngx-toastr';
import { AlertasService } from 'src/app/_services/alertas.service';
import { MzModalComponent } from 'ngx-materialize';
import { environment } from 'src/environments/environment';
import { SessionService } from 'src/app/_services/session.service';
import { CookieService } from 'ngx-cookie-service';
import { Globals } from 'src/app/_services/zero/globals';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class NavbarComponent implements OnInit {
  @ViewChild('bottomSheetModal') modal: MzModalComponent;
  public totalAlertas: number;
  usernameauth: String;
  esquema: String;
  idesquema: String;
  public rol: string;
  public rolauth: number = 0;
  public time: string;

  constructor(private router: Router,
    private authenticationService: AuthenticationService,
    private zeroService: ZeroService,
    private toastr: ToastrService
    , private alert: AlertasService,
    private session: SessionService,
    private cookieService: CookieService,
    public globals: Globals,
  ) {
    this.time = new Date().getTime().toString();
  }

  ngOnInit() {
    this.usernameauth = this.authenticationService.currentUserValue.username;
    this.esquema = this.authenticationService.currentUserValue.esquema;
    this.idesquema = this.authenticationService.currentUserValue.idEsquema;
    this.alert.getAlertas().subscribe(x => {
      this.totalAlertas = x;
    });
    this.alert.consultarTotalAlertas();
    this.time = new Date().getTime().toString();
    // Role especify
    switch (this.authenticationService.currentUserValue.role) {

      case Role.Ejecutor:
        this.rolauth = 1;
        this.rol = "Ejecutor";
        break;
      case Role.Supervisor:
        this.rolauth = 2;
        this.rol = "Supervisor";
        break;
      case Role.Prevencion:
        this.rolauth = 3;
        this.rol = "Prevención";
        break;
      case Role.Auditoria:
        this.rolauth = 4;
        this.rol = "Auditoria";
        break;
      case Role.Administrador:
        this.rolauth = 5;
        this.rol = "Administrador";
        break;
      default:
        this.rolauth = 0;
        break;

    }

    localStorage.setItem('currentRol', this.rol);
  }

  consultarTotalAlertas() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.BUSQUEDA_TOTAL_ALERTAS,
      method: "GET",
      showInfo: true,
      ok: (response) => {
        if (response.responsecode == "0") {
          scope.totalAlertas = response.response.totalAlerts;
        } else {
          scope.totalAlertas = 0;
        }
      },
      error: (response) => {
        console.log("entro error");
        scope.totalAlertas = 0;
      }
    });
  }

  logout() {
    var scope = this;
    this.zeroService.request({
        uri: environment.uris.comunes.borrarPerfilamiento,
        method: "DELETE",
        ok: response => {
            if (response.response) {
              console.log("Se borro redis.");
              console.log("Se borrara session storage.");
              scope.session.deleteFromSession("perfiles");
              console.log("Se borrara cookie.");
              scope.cookieService.delete(environment.app);
              scope.cookieService.deleteAll();
              console.log("Se borrara local storage.");
              scope.authenticationService.changeScheme();
              console.log("Se dara logout en Forgerock.");
              scope.globals = new Globals();         
              let news = window.open("", "cerrarSesion", "width=600, height=200");
              let tmot = setTimeout(() => { window.open(environment.uris.comunes.logout, "cerrarSesion") }, 0);
              tmot = setTimeout(() => { news.close(); window.location.href = environment.uris.comunes.login; }, 1500);
            }
        }
    });
  }


  mostrarNotificaciones() {
    this.router.navigate(['alertas'], {
      queryParams: { refresh: new Date().getTime() }
    });
  }

  abrirModalContingencia() {
    this.modal.openModal();
  }

  activarContingencia() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.ACTIVAR_CONTINGENCIA,
      method: "POST",
      showInfo: true,
      ok: (response) => {
        if(response.responsecode == "0") {
          scope.toastr.success('<h5>Mensaje de sistema...</h5> <span>La solicitud ha sido generada exitosamente, la generación del archivo se esta procesando, este proceso puede tardar de 10 a 20 minutos, revisar alertas</span>', "",
            { closeButton: false, enableHtml: true, timeOut : 5000});
        }
      }
    })
  }

  changeEscheme() {
    this.authenticationService.changeScheme();
    this.router.navigate(['']);
  }

}
